import type React from 'react';

/* eslint-disable no-nested-ternary */
import {
  Button,
  Col, Input, Row, Switch,
} from 'antd';
import DrawerAlerts from 'Components/alerts/components/DrawerAlerts';
import SearchGlobalIcon from 'Components/common/assets/svgIcons/SearchGlobalIcon';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import GlobalButton from 'Components/common/components/GlobalButton';
import GlobalSearch from 'Components/globalSearch/components/GlobalSearch';
import NavBarPrimary from 'Components/layout/headers/NavBarPrimary';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  getLocalStorageValue,
  isActive,
  IsTablet,
  setLocalStorageValue,
  validateSearchQuery,
} from 'Utils/UtilityFunctions';
import {
  greyColor,
  maxMobile,
  maxTablet,
  maxWidth,
  maxWidth1300,
  midMobile,
  minExtraLargeScreen,
  minRegularScreen,
  primaryColor,
  primaryFont,
  primaryHeadingColor,
  retina,
  scrollbar,
  SecondaryColorTwo,
  secondaryFont,
  textBlack,
  wLight,
  wMBold,
  wMedium,
} from 'Utils/utilsStyle';

import InfiniteScroll from 'react-infinite-scroll-component';
import { useEffect, useRef, useState } from 'react';
import CompanySkeleton from 'Components/common/skeleton/CompanySkeleton';
import Cross from 'Components/globalSearch/assets/Cross';
import { TOOLTIP_DAILYIQ, translateSkipAreas } from 'Utils/Constants';
import { usePrevious } from 'Utils/hooks/usePrevious';
import InfoIconTwo from 'Components/common/assets/svgIcons/InfoIconTwo';
import { actions as settingsActions } from 'Slice/SettingsSlice';
import {
  searchComapniesCount,
  searchCompaniesSubscribedCount,
  selectCompanies,
  selectCompaniesLoading,
  selectCompanyCount,
  selectLoadMore,
  selectStatus,
  selectSubscribedCount,
} from 'Selector/CompaniesSelector';
import { actions as companiesActions } from 'Slice/CompaniesSlice';
import type { SearchListItem } from 'Types/GlobalTypes'; // Adjust the path as needed
import { RootState } from 'Store/InjectorsTypes';
import { cp } from 'fs';
import FilterDropdown from 'Components/common/components/FilterDropdown';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import type { Company } from '../../Types/CompaniesTypes';
import CompanyCardLarge from '../../Components/common/components/CompanyCardLarge';

const StyleWrapper = styled.div<{ sectionHeight: number }>`
background: #f2f2f2;
.main-container {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  justify-content: center;
  align-items: center;
  width: 85%;
  margin: auto;
  padding: 0px 15px;
  /* @media all and (min-width: 1920px) {
    width: 1550px;
  }
  @media all and (max-width: ${maxWidth1300}) {
    width: 100%;
  }
  @media all and (max-width: ${minRegularScreen}) {
    width: 780px;
  } */
  @media all and (max-width: ${maxTablet}) {
    width: 85%;
  }
  @media all and (max-width: ${maxMobile}) {
    width: 550px;
  }
  @media all and (max-width: ${midMobile}) {
    width: 370px;
  }
  .first-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    background: #FFF;
    margin-top: 42px;
    padding: 16px 34px 16px 36px;
    width: 100%;
    @media all and (max-width: ${midMobile}) {
      padding: 16px;
    }
    .left-side {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
      .main-heading {
        color: ${primaryHeadingColor};
        font-family: ${primaryFont};
        font-size: 30px;
        font-weight: ${wMBold};
        line-height: 32px;
        letter-spacing: -0.9px;
        margin-bottom: 0px;
        @media all and (max-width: ${maxTablet}) {
          font-size: 22px;
          line-height: 20px;
        }
      }
      .sub-heading {
        color: ${SecondaryColorTwo};
        font-family: ${primaryFont};
        font-size: 16px;
        font-weight: ${wLight};
        line-height: 21px;
        letter-spacing: -0.556px;
        margin-bottom: 0px;
        @media all and (max-width: ${maxTablet}) {
          font-size: 14px;
        }
        @media all and (max-width: ${midMobile}) {
          font-size: 12px;
          line-height: normal;
        }
      }
    }
    .right-side {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 8px;
      p {
        margin-bottom: 0px;
        color: ${greyColor};
        text-align: right;
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMedium};
        line-height: 20px;
        letter-spacing: -0.4px;
      }
      .ant-switch {
        background:  linear-gradient(90deg,rgba(0,0,0,.25),rgba(0,0,0,.25)),linear-gradient(90deg,#fff,#fff) !important;
        &.ant-switch-checked {
          background-image: linear-gradient(90deg,#1EC252,#1EC252),linear-gradient(90deg,#fff,#fff) !important;
        }
      }
    }
  }
  .second-section {
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 100%;
    .headings-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 32px;
      border-radius: 10px 10px 0px 0px;
      background: #FFF;
      @media all and (max-width: ${midMobile}) {
        padding: 16px 12px;
        flex-direction: column;
        align-items: normal;
        gap: 8px;
      }
      .headings {
        display: flex;
        flex-direction: column;
        row-gap: 4px;
        @media all and (max-width: ${midMobile}) {
          row-gap: 8px;
        }
        .main-heading {
          display: flex;
          align-items: center;
          color:${primaryHeadingColor};
          font-family: ${primaryFont};
          font-size: 30px;
          font-weight: ${wMBold};
          line-height: 32px;
          letter-spacing: -0.9px;
          @media all and (max-width: ${maxTablet}) {
            font-size: 22px;
            line-height: 20px;
          }
          .global-tooltip-element svg {
            cursor: pointer;
            @media all and (max-width: ${maxMobile}) {
            display: none;
          }
          }
          .tooltip_wrapper .tooltip-text-tour {
            letter-spacing: 0px;
          }
        }
        .sub-heading {
          color: ${SecondaryColorTwo};
          font-family: ${primaryFont};
          font-size: 16px;
          font-weight: ${wLight};
          line-height: 21px;
          letter-spacing: -0.556px;
          @media all and (max-width: ${maxWidth1300}) {
            font-size: 14px;
          }
          @media all and (max-width: ${minRegularScreen}) {
            display: none;
          }
        }
      }
      .filter-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        .filter-btn {
        display: flex;
        cursor: pointer;
        padding: 12px;
        color: ${greyColor};
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        letter-spacing: -0.424px;
        width: 85px;
        &:hover {
          border-color: ${primaryColor} !important;
        }
      }
      .submit-btn {
        width: 63px;
        font-size: 12px;
        padding: 0;
        display: block;
      }
      .search-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 320px;
        position: relative;
        @media all and (max-width: ${maxMobile}) {
            max-width: 104px;
          }
        @media all and (max-width: ${maxTablet}) {
          max-width: 170px;
        }
        .ant-input-affix-wrapper {
          padding: 4px 12px;
          border-radius: 6px;
          border: 1px solid #DADADA;
          background: #FFF;
          @media all and (max-width: ${midMobile}) {
            max-width: 216px
          }
          .ant-input-prefix {
            .search-global-icon-svg {
              width: 18px;
              height: 18px;
              path {
                fill: #7E7E7E;
              }
            }
          }
          .ant-input {
            ::placeholder {
              color: #C1C1C1;
              font-family: ${primaryFont};
              font-size: 14px;
              font-style: italic;
              font-weight: ${wLight};
              line-height: 16px;
              letter-spacing: -0.45px;
            }
            color: ${textBlack};
            font-family: ${primaryFont};
            font-size: 14px;
            font-style: normal;
            font-weight: ${wMedium};
            line-height: normal;
          }
        }
        .clear-search {
          position: absolute;
          right: 2%;
          z-index: 1;
          cursor:pointer;
        }
      }
      }
    }
    .companies-section {
      height: 100dvh;
      min-height: fit-content;
      padding: 12px 32px;
      border-radius: 0px 0px 10px 10px;
      background: #FFF;
      @media all and (max-width: ${midMobile}) {
        padding: 12px 16px;
      }
      .company-display {
        margin-top: 14px;
        padding: 0px 13px;
        ${scrollbar};
        ::-webkit-scrollbar { width: 4px;}
        ::-webkit-scrollbar-track { background-color: transparent; border-radius: 2px;}
        @media all and (max-width: ${midMobile}) {
          padding: 0px;
        }
        .ant-row {
          padding: 12px;
          &.Grid-width-row {
            .ant-col {
            margin-bottom: 8px;
            @media all and (max-width: 1600px) {
                flex: 0 0 20% !important;
                max-width: 20% !important;
              }
              @media all and (max-width: 1450px) {
                flex: 0 0 25% !important;
                max-width: 25% !important;
              }
              @media all and (max-width: ${maxTablet}) {
                flex: 0 0 33.33% !important;
                max-width: 33.33% !important;
              }
              @media all and (max-width: ${maxMobile}) {
                flex: 0 0 50% !important;
                max-width: 50% !important;
              }
              .company-item {
                .follow-action {
                  display: none;
                }
                .check_label {
                  .exceptButtonContent {
                    .company-image-parent {
                      margin: 0px 0px 12px 0px;
                    }
                    .company-naves {
                      .companyName {
                        @media all and (max-width: ${maxWidth}), ${retina} {
                          margin-bottom: 8px;
                        }
                        @media all and (max-width: ${maxTablet}) {
                          min-height: 20px;
                          margin-bottom: 0px;
                        }
                      }
                    }
                  }
                  .ant-checkbox-wrapper {
                    .ant-checkbox-inner {
                      width: 24px !important;
                      height: 24px !important;
                      ::after {
                        top: 47%;
                        left: 30.5%;
                        @media all and (max-width: ${midMobile}) {
                          top: 45%;
                        }
                      }
                      @media all and (max-width: ${midMobile}) {
                        width: 18px !important;
                        height: 18px !important;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .no-data {
          height: calc(100vh - ${({ sectionHeight }) => sectionHeight + 164}px);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px;
          .no-results {
            color: ${primaryHeadingColor};
            font-family: ${secondaryFont};
            font-size: 30px;
            font-weight: 700;
            line-height: 32px;
            letter-spacing: -0.9px;
            @media all and (max-width: ${midMobile}) {
              font-size: 22px;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
`;
const DailyIQCompanies = function DailyIQCompanies() {
  const isTab = IsTablet();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const companies: Company[] = useSelector(selectCompanies);
  const loading: boolean = useSelector(selectCompaniesLoading);
  const status: boolean = useSelector(selectStatus) ?? false;
  const companiesLength: number = useSelector(selectCompanies).length;
  const companiesCount: number = useSelector(selectCompanyCount);
  const searchCount: number = useSelector(searchComapniesCount);
  const loadMore: boolean = useSelector(selectLoadMore) ?? false;
  const searchSubscribedCount = useSelector(searchCompaniesSubscribedCount);
  const initialSubscribedCount: number = useSelector(selectSubscribedCount) ?? 0;
  const container1Ref = useRef<HTMLDivElement>(null);
  const container2Ref = useRef<HTMLDivElement>(null);
  const container3Ref = useRef<HTMLDivElement>(null);
  const [companyHeight, setCompanyHeight] = useState(0);
  const [subscribedCompanies, setSubsrcibedCompanies] = useState<number[]>([]);
  const [unsubscribedCompanies, setUnSubscribedCompanies] = useState<number[]>([]);
  // const [tempCount, setTempCount] = useState<number>(0);
  const [currentValue, setCurrentValue] = useState(getLocalStorageValue('subscription') === 'True');
  const [searchText, setSearchText] = useState<string>('');
  const [value, setValue] = useState<string>('');
  const subscribedCount = useSelector((state: RootState) => state?.companies?.subscribedCount);
  const [localSubscribedCount, setLocalSubscribedCount] = useState<number>(initialSubscribedCount);
  const [localSearchSubscribedCount, setLocalSearchSubscribedCount] = useState<number>(searchSubscribedCount);
  const [localCount, setLocalCount] = useState<number>(0);
  const [searchList, setSearchList] = useState<SearchListItem[]>([]);
  const [selectedCompanies, setSelectedCompanies] = useState<number[]>([]);
  const [unselectedCompanies, setUnselectedCompanies] = useState<number[]>([]);
  const [isToggleClicked, setIsToggleClicked] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isSearchAllSelected, setIsSearchAllSelected] = useState(false);
  const hasCompanyselection = selectedCompanies.length > 0 || searchList.some((item) => item.subscribedCompanies.length > 0) || unselectedCompanies.length > 0 || searchList.some((item) => item.unsubscribedCompanies.length > 0);
  const isDisabled = !(hasCompanyselection) || loading;
  // Determine the toggle text
  const [toggleText, setToggleText] = useState(isAllSelected ? 'Unselect All' : 'Select All');
  const searchToggleText = isSearchAllSelected ? 'Unselect All' : 'Select All';
  const [toggleSource, setToggleSource] = useState<'main' | 'search'>('main');
  const [allSelectedCompanyIds, setAllSelectedCompanyIds] = useState<number[]>([]);
  const filterOptions = [
    { value: 'check', label: 'Check', selected: false },
    { value: 'uncheck', label: 'Uncheck', selected: false },
  ];
  // Handle toggle functionality
  const handleToggle = () => {
    const source = searchText.length > 0 ? 'search' : 'main';
    const visibleCompanyIds = companies.map((company) => company.companyId);
    setToggleSource(source);

    // Update searchList if in search
    if (source === 'search') {
      if (isSearchAllSelected) {
        // === UNSELECT ALL ===
        setIsToggleClicked(true);
        setIsSearchAllSelected(false);
        setSubsrcibedCompanies([]);
        setSelectedCompanies([]);
        setAllSelectedCompanyIds([]);
        setUnSubscribedCompanies(visibleCompanyIds);
        setUnselectedCompanies(visibleCompanyIds);
        setSearchList((prev) => {
          const existingIndex = prev.findIndex((item) => item.searchTerm === searchText);
          const updated = [...prev];

          if (existingIndex !== -1) {
            updated[existingIndex] = {
              ...updated[existingIndex],
              isSelectAll: false,
              subscribedCompanies: [],
              unsubscribedCompanies: visibleCompanyIds,
            };
          } else {
            updated.push({
              searchTerm: searchText,
              isSelectAll: false,
              subscribedCompanies: [],
              unsubscribedCompanies: visibleCompanyIds,
            });
          }
          return updated;
        });
      } else {
        // === SELECT ALL ===
        setIsSearchAllSelected(true);
        setIsToggleClicked(true);
        setSubsrcibedCompanies(visibleCompanyIds);
        setSelectedCompanies(visibleCompanyIds);
        setAllSelectedCompanyIds(visibleCompanyIds);
        setUnSubscribedCompanies([]);
        setUnselectedCompanies([]);
        setSearchList((prev) => {
          const existingIndex = prev.findIndex((item) => item.searchTerm === searchText);
          const updated = [...prev];

          if (existingIndex !== -1) {
            updated[existingIndex] = {
              ...updated[existingIndex],
              isSelectAll: true,
              subscribedCompanies: visibleCompanyIds,
              unsubscribedCompanies: [],
            };
          } else {
            updated.push({
              searchTerm: searchText,
              isSelectAll: true,
              subscribedCompanies: visibleCompanyIds,
              unsubscribedCompanies: [],
            });
          }
          return updated;
        });
      }
    } else if (isAllSelected) {
      // === UNSELECT ALL ===
      setIsAllSelected(false);
      setIsToggleClicked(true);
      setSubsrcibedCompanies([]);
      setSelectedCompanies([]);
      setUnSubscribedCompanies([]);
      setUnselectedCompanies([]);
      setAllSelectedCompanyIds([]);
    } else {
      // === SELECT ALL ===
      setIsAllSelected(true);
      setIsToggleClicked(true);
      setSubsrcibedCompanies(visibleCompanyIds);
      setSelectedCompanies(visibleCompanyIds);
      setAllSelectedCompanyIds(visibleCompanyIds);
      setUnSubscribedCompanies([]);
      setUnselectedCompanies([]);
    }
  };
  useEffect(() => {
    if (isAllSelected && isToggleClicked && toggleSource === 'main') {
      setIsAllSelected(true);
      setToggleText('Unselect All');
      setLocalSubscribedCount(companiesCount);
      setLocalCount(companiesCount);
      setSearchList([]);
    }
    if (!isAllSelected && isToggleClicked && toggleSource === 'main') {
      setIsAllSelected(false);
      setToggleText('Select All');
      setSearchList([]);
      setLocalSubscribedCount(0);
    }
    if (isAllSelected && toggleSource === 'main' && localSearchSubscribedCount === searchCount && (localSearchSubscribedCount !== 0 && searchCount !== 0)) {
      setIsSearchAllSelected(true);
    }
    if (isSearchAllSelected && isToggleClicked && toggleSource === 'search') {
      setIsSearchAllSelected(true);
    }
    if (!isSearchAllSelected && isToggleClicked && toggleSource === 'search') {
      setIsSearchAllSelected(false);
      setSubsrcibedCompanies([]);
    }
  }, [isAllSelected, toggleSource]);
  useEffect(() => {
    if (searchText.trim() === '' && localSubscribedCount === companiesCount && toggleSource === 'main') {
      setIsAllSelected(true);
      setToggleText('Unselect All');
    }
    if (searchText.trim() === '' && localSubscribedCount !== companiesCount && toggleSource === 'main') {
      setIsAllSelected(false);
      setToggleText('Select All');
    }
    if (searchText.trim() !== '' && localSearchSubscribedCount === searchCount && (localSearchSubscribedCount !== 0 && searchCount !== 0)) {
      setIsSearchAllSelected(true);
    }
    if (searchText.trim() !== '' && localSearchSubscribedCount !== searchCount) {
      setIsSearchAllSelected(false);
    }
    if (localSearchSubscribedCount === searchCount && searchText.trim() !== '' && searchList.length > 0) {
      setIsSearchAllSelected(true);
    }
    if (localSearchSubscribedCount !== searchCount && searchText.trim() !== '' && searchList.length > 0) {
      setIsSearchAllSelected(false);
    }
  }, [localSubscribedCount, localSearchSubscribedCount]);
  // Update localSubscribedCount whenever subscribedCount changes
  useEffect(() => {
    setLocalSubscribedCount(subscribedCount ?? 0);
    setLocalSearchSubscribedCount(searchSubscribedCount ?? 0);
  }, [subscribedCount, searchSubscribedCount]);

  // Initialize subscribed and removed companies when companies list changes | Use Case: when you select company and call pagination | search company then close search and pagination call, previous company and new company both visible
  useEffect(() => {
    if ((searchText.trim() === '' && searchList.length > 0) || (searchText.trim() === '' && selectedCompanies.length === 0 && unselectedCompanies.length === 0)) {
      const initialSubscribed = companies
        .filter((company) => company.companySubscribed)
        .map((company) => company.companyId);
      const initialRemoved = companies
        .filter((company) => !company.companySubscribed)
        .map((company) => company.companyId);
      setSubsrcibedCompanies(initialSubscribed);
      setUnSubscribedCompanies(initialRemoved);
    }
    if (searchText.trim() === '' && localCount !== companiesCount && toggleSource === 'main') {
      setToggleText('Select All');
    }
    if ((searchText.trim() !== '') && (searchSubscribedCount === searchCount) && !isToggleClicked && toggleSource === 'search') {
      setIsSearchAllSelected(true);
    }
    if (searchText.trim() !== '' && (searchSubscribedCount !== searchCount) && !isToggleClicked && toggleSource === 'search') {
      setIsSearchAllSelected(false);
    }
    if ((searchText.trim() !== '') && (searchSubscribedCount === searchCount) && isToggleClicked && toggleSource === 'search') {
      setIsSearchAllSelected(true);
    }
    if (searchText.trim() !== '' && (searchSubscribedCount !== searchCount) && isToggleClicked && toggleSource === 'search') {
      setIsSearchAllSelected(false);
    }
    if ((searchText.trim() !== '') && (searchSubscribedCount === searchCount) && !isToggleClicked && toggleSource === 'main') {
      setIsSearchAllSelected(true);
    }
    if (searchText.trim() !== '' && (searchSubscribedCount !== searchCount) && !isToggleClicked && toggleSource === 'main') {
      setIsSearchAllSelected(false);
    }
  }, [companies, searchText]);

  const submitCompanies = () => {
    const mergedSubscribed = Array.from(new Set([
      ...subscribedCompanies,
      ...selectedCompanies,
    ])).filter(
      (id) => !unsubscribedCompanies.includes(id)
        && !unselectedCompanies.includes(id),
    );

    // Include all unsubs from both sources
    const mergedUnsubscribed = Array.from(new Set([
      ...unsubscribedCompanies,
      ...unselectedCompanies,
    ]));
    const payload: any = {
      offset: 0,
      searchList: searchList.map((item) => {
        const updatedItem: {
          searchTerm: string;
          subscribedCompanies: any;
          unsubscribedCompanies: any;
          isSelectAll?: boolean;
        } = {
          searchTerm: item.searchTerm,
          subscribedCompanies: item.isSelectAll ? '' : selectedCompanies.length > 0 ? item.subscribedCompanies.join(',') : '',
          unsubscribedCompanies: item.isSelectAll ? '' : unselectedCompanies.length > 0 ? item.unsubscribedCompanies.join(',') : '',
        };

        if (isSearchAllSelected && isToggleClicked && toggleSource === 'search') {
          updatedItem.isSelectAll = true; // ✅ Add isSelectAll inside searchList object
        }
        if (!isSearchAllSelected && isToggleClicked && toggleSource === 'search') {
          updatedItem.isSelectAll = false; // ✅ Add isSelectAll inside searchList object
        }
        if (!isSearchAllSelected && !isToggleClicked && toggleSource === 'search') {
          delete (updatedItem as any).isSelectAll; // ✅ Add isSelectAll inside searchList object
        }
        // Handle 'main' toggle case (remove isSelectAll if not needed)
        if (toggleSource === 'main' && !isToggleClicked) {
          const { isSelectAll, ...rest } = item; // Remove isSelectAll
          return {
            ...rest,
            subscribedCompanies: rest.subscribedCompanies?.join(',') || '',
            unsubscribedCompanies: rest.unsubscribedCompanies?.join(',') || '',
          };
        }
        return updatedItem; // Return the updated item with isSelectAll if needed
      }),
      operation: 'submit',
    };
    if ((searchText.length > 0 && loadMore) || (searchText.length === 0 && loadMore)) {
      payload.offset = companiesLength;
    }
    // Always include main selection if present
    if (mergedSubscribed.length > 0 && selectedCompanies.length > 0 && !isAllSelected) {
      payload.subscribedCompanies = mergedSubscribed.join(',');
    }
    if (mergedUnsubscribed.length > 0 && unselectedCompanies.length > 0 && !isAllSelected) {
      payload.unsubscribedCompanies = mergedUnsubscribed.join(',');
    }
    // If Select All is active, handle as before
    if (isAllSelected) {
      payload.isSelectAll = true;
      payload.subscribedCompanies = '';
      payload.unsubscribedCompanies = (mergedUnsubscribed.length > 0 && unselectedCompanies.length > 0) ? mergedUnsubscribed.join(',') : '';
    } if (!isAllSelected && isToggleClicked && toggleSource === 'main') {
      payload.isSelectAll = false;
      payload.subscribedCompanies = mergedSubscribed.length > 0 ? mergedSubscribed.join(',') : '';
      payload.unsubscribedCompanies = '';
    }

    // If no searchList and no main selection, remove those keys
    if (
      (!mergedSubscribed.length && !mergedUnsubscribed.length)
      && searchList.length === 0
    ) {
      delete payload.subscribedCompanies;
      delete payload.unsubscribedCompanies;
    }

    dispatch(companiesActions.getDailyIQCompanies(payload));
    // if (isAllSelected && searchText.length && searchList.length) {
    //   setIsToggleClicked(false);
    //   setIsAllSelected(false);
    // }
    setIsToggleClicked(false);
    // setIsAllSelected(false);
    setSearchList([]);
    setSearchText('');
    setValue('');
    setSelectedCompanies([]);
    setUnselectedCompanies([]);
    setToggleSource('main');
    if (searchText.length > 0) {
      setTimeout(() => {
        setSearchText('');
        setValue('');
        setSelectedCompanies([]);
        setUnselectedCompanies([]);
        dispatch(companiesActions.getDailyIQCompanies({
          offset: 0,
          searchTerm: '',
          operation: 'view',
        }));
      }, 2000);
    }
  };
  useEffect(() => {
    const container1Height = container1Ref.current?.offsetHeight || 0;
    const container2Height = container2Ref.current?.offsetHeight || 0;
    const container3Height = container3Ref.current?.offsetHeight || 0;

    const totalHeight = container1Height + container2Height + container3Height;
    setCompanyHeight(totalHeight);
  }, []);
  const fetchMoreCompanies = () => {
    const mergedSubscribed = Array.from(new Set([
      ...subscribedCompanies,
      ...selectedCompanies,
    ])).filter(
      (id) => !unsubscribedCompanies.includes(id) && !unselectedCompanies.includes(id),
    );

    const mergedUnsubscribed = Array.from(new Set([
      ...unsubscribedCompanies,
      ...unselectedCompanies,
    ])).filter(
      (id) => !subscribedCompanies.includes(id) && !selectedCompanies.includes(id),
    );

    const payload: any = {
      searchTerm: searchText,
      offset: companiesLength,
      loadMore: true,
    };

    if (searchList.length > 0) {
      payload.searchList = searchList.map((item) => {
        const includeSelectAll = typeof item.isSelectAll === 'boolean'
          && toggleSource === 'search'
          && isToggleClicked;

        return {
          searchTerm: item.searchTerm,
          ...(includeSelectAll ? { isSelectAll: item.isSelectAll } : {}),
          subscribedCompanies: item.isSelectAll ? '' : selectedCompanies.length > 0 ? item.subscribedCompanies.join(',') : '',
          unsubscribedCompanies: item.isSelectAll ? '' : unselectedCompanies.length > 0 ? item.unsubscribedCompanies.join(',') : '',
        };
      });
    }

    // ✅ Select All toggle (main)
    if (isAllSelected && isToggleClicked && toggleSource === 'main') {
      payload.isSelectAll = true;
      delete payload.subscribedCompanies;
      delete payload.unsubscribedCompanies;
    }
    // Select All toggle (main) but source (search)
    else if (isAllSelected && isToggleClicked && toggleSource === 'search') {
      payload.isSelectAll = true;
      delete payload.subscribedCompanies;
      delete payload.unsubscribedCompanies;
    }
    // ✅ Unselect All toggle (main)
    else if (!isAllSelected && isToggleClicked && toggleSource === 'main') {
      payload.isSelectAll = false;

      // Only include manually selected companies if any
      if (selectedCompanies.length > 0) {
        const filteredSelected = Array.from(new Set(selectedCompanies))
          .filter((id) => !unsubscribedCompanies.includes(id)
            && !unselectedCompanies.includes(id));

        if (filteredSelected.length > 0) {
          payload.subscribedCompanies = filteredSelected.join(',');
        }
      }

      // Only include manually unselected companies if any
      const hasManualUnselects = unselectedCompanies.length > 0 || unsubscribedCompanies.length > 0;
      if (hasManualUnselects) {
        payload.unsubscribedCompanies = Array.from(new Set([
          ...unsubscribedCompanies,
          ...unselectedCompanies,
        ])).join(',');
      } else {
        delete payload.unsubscribedCompanies;
      }
    }
    // ✅ Default case (non-toggle)
    else {
      if (mergedSubscribed.length > 0) {
        payload.subscribedCompanies = mergedSubscribed.join(',');
      }

      if (mergedUnsubscribed.length > 0) {
        payload.unsubscribedCompanies = mergedUnsubscribed.join(',');
      }

      delete payload.isSelectAll;
    }

    dispatch(companiesActions.getDailyIQCompanies(payload));
  };

  const getCompaniesLoadingSkeleton = () => {
    const skeletons = [];
    for (let i = 0; i < 11; i += 1) {
      skeletons.push(
        <Col
          xxl={{ span: 4 }}
          xl={{ span: 4 }}
          lg={{ span: 8 }}
          md={{ span: 12 }}
          sm={{ span: 12 }}
          className="gutter-row"
        >
          <CompanySkeleton />
        </Col>,
      );
    }
    return (
      <Row gutter={[24, 24]} className="Grid-width-row lastTwoRemove">
        {skeletons}
      </Row>
    );
  };
  const stopEmail = () => {
    setCurrentValue((prevValue) => {
      const newVal = !prevValue;
      if (newVal) {
        setLocalStorageValue('subscription', 'True');
      } else {
        setLocalStorageValue('subscription', 'False');
      }
      const toggleData = {
        fullname: '',
        email: '',
        old_password: '',
        password: '',
        profilepic: '',
        phone: '',
        subscription: getLocalStorageValue('subscription') || '',
        toggle: true,
      };
      dispatch(settingsActions.updateSetting(toggleData));
      return newVal;
    });
  };
  const clearSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue('');
    e.stopPropagation();

    setTimeout(() => {
      const payload: any = {
        offset: 0,
        searchList: searchList.map((item) => {
          const updatedItem: {
            searchTerm: string;
            subscribedCompanies: any;
            unsubscribedCompanies: any;
            isSelectAll?: boolean;
          } = {
            searchTerm: item.searchTerm,
            subscribedCompanies: item.isSelectAll ? '' : selectedCompanies.length > 0 ? item.subscribedCompanies.join(',') : '',
            unsubscribedCompanies: item.isSelectAll ? '' : unselectedCompanies.length > 0 ? item.unsubscribedCompanies.join(',') : '',
          };

          if (isSearchAllSelected && toggleSource === 'search') {
            updatedItem.isSelectAll = true; // ✅ Add isSelectAll inside searchList object
          }
          if (!isSearchAllSelected && toggleSource === 'search') {
            updatedItem.isSelectAll = false; // ✅ Add isSelectAll inside searchList object
          }
          if (!isSearchAllSelected && !isToggleClicked) {
            delete (updatedItem as any).isSelectAll; // ✅ Add isSelectAll inside searchList object
          }
          return updatedItem;
        }),
        operation: 'view',
        // Always use the current main selection for outer payload
        // subscribedCompanies: mergedSubscribed.length > 0 ? mergedSubscribed.join(',') : '',
        // unsubscribedCompanies: mergedUnsubscribed.length > 0 ? mergedUnsubscribed.join(',') : '',
      };
      if (selectedCompanies.length > 0 && searchList.length === 0) {
        payload.subscribedCompanies = selectedCompanies.join(',');
      }
      if (unselectedCompanies.length > 0 && searchList.length === 0) {
        payload.unsubscribedCompanies = unselectedCompanies.join(',');
      }
      if (isAllSelected && toggleSource === 'main' && isToggleClicked) {
        payload.isSelectAll = true;
      }
      if (isAllSelected && toggleSource === 'search' && isToggleClicked) {
        payload.isSelectAll = true;
      }
      if (!isAllSelected && toggleSource === 'main' && isToggleClicked) {
        payload.isSelectAll = false;
      }
      // if (!isAllSelected && toggleSource === 'search' && isToggleClicked) {
      //   payload.isSelectAll = false;
      // }
      if (!isAllSelected && toggleSource === 'main' && !isToggleClicked) {
        delete payload.isSelectAll;
      }
      dispatch(companiesActions.getDailyIQCompanies(payload));
      // setIsToggleClicked(false);
      // setIsAllSelected(false);
      setLocalSearchSubscribedCount(0);
      setSearchText('');
    }, 0);
  };
  const searchQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    if (e.target.value.length === 0) {
      setSearchText('');
      clearSearch(e);
    }
    e.stopPropagation();
  };
  const handleSearch = (keyword: string) => {
    if (keyword.length) {
      const searchQuery = validateSearchQuery(keyword.trim());
      setSearchText(searchQuery);
      if (searchQuery.length === 0) return;

      const mergedSubscribed = Array.from(new Set([...selectedCompanies]));
      const mergedUnsubscribed = Array.from(new Set([...unselectedCompanies]));
      const payload: any = {
        searchTerm: searchQuery,
        offset: 0,
        subscribedCompanies: '',
        unsubscribedCompanies: '',
        searchList: searchList.map((item) => ({
          searchTerm: item.searchTerm,
          isSelectAll: item.isSelectAll,
          subscribedCompanies: item.subscribedCompanies.join(','),
          unsubscribedCompanies: item.unsubscribedCompanies.join(','),
        })),
        operation: 'view' as const,
      };

      if (isAllSelected && toggleSource === 'main' && isToggleClicked) {
        payload.isSelectAll = true;
        payload.subscribedCompanies = '';
      } else if (!isAllSelected && toggleSource === 'main' && isToggleClicked) {
        payload.isSelectAll = false;
        payload.unsubscribedCompanies = '';
      } else {
        payload.subscribedCompanies = mergedSubscribed.join(',');
        payload.unsubscribedCompanies = mergedUnsubscribed.join(',');
        delete payload.isSelectAll;
      }

      dispatch(companiesActions.getDailyIQCompanies(payload));
    } else {
      setSelectedCompanies([]);
      setUnselectedCompanies([]);
      setSearchText('');
    }
  };
  useEffect(() => {
    // Only fetch companies on initial mount (no search)
    dispatch(companiesActions.getDailyIQCompanies({
      offset: 0,
      searchTerm: '',
      operation: 'view',
    }));
  }, [dispatch]);
  const triggerSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch(value);
    }
  };
  const handleRemoveCompany = (selected?: boolean, companyId?: number) => {
    // Early return if companyId is undefined
    if (companyId === undefined) return;

    // Use nullish coalescing to ensure selected is a boolean
    const isSelected = selected ?? false;

    // Handle global state (for non-search mode)
    if (isSelected) {
      setSelectedCompanies((prev) => (prev.includes(companyId) ? prev : [...prev, companyId]));
      setUnselectedCompanies((prev) => prev.filter((id) => id !== companyId));
      setSubsrcibedCompanies((prev) => (prev.includes(companyId) ? prev : [...prev, companyId]));
      setUnSubscribedCompanies((prev) => prev.filter((id) => id !== companyId));
      setLocalSubscribedCount(localSubscribedCount + 1);
      setLocalCount(localCount + 1);
    } else {
      setUnselectedCompanies((prev) => (prev.includes(companyId) ? prev : [...prev, companyId]));
      setSelectedCompanies((prev) => prev.filter((id) => id !== companyId));
      setUnSubscribedCompanies((prev) => (prev.includes(companyId) ? prev : [...prev, companyId]));
      setSubsrcibedCompanies((prev) => prev.filter((id) => id !== companyId));
      setLocalSubscribedCount(localSubscribedCount - 1);
      setLocalCount(localCount - 1);
    }
    // Update searchList in non-search mode to clear stale entries
    if (!searchText.length) {
      const company = companies.find((c) => c.companyId === companyId);
      if (company) {
        const companyName = company.companyName.toLowerCase();
        setSearchList((prev) =>
          // Remove entries where companyId is in subscribedCompanies or unsubscribedCompanies
          prev.filter(
            (item) => !item.subscribedCompanies.includes(companyId)
              && !item.unsubscribedCompanies.includes(companyId)
              && item.searchTerm !== companyName,
          ));
      }
    }
    // Handle search mode
    if (searchText.length > 0) {
      setSearchList((prev) => {
        const currentCompanies = companies.map((c) => c.companyId);
        const existingItem = prev.find((item) => item.searchTerm === searchText);

        // Get existing settings for this search, if any
        const existingSubscribed = existingItem?.subscribedCompanies || [];
        const existingUnsubscribed = existingItem?.unsubscribedCompanies || [];

        // Calculate which companies should be shown as selected/unselected
        let newSubscribed: number[] = [];
        let newUnsubscribed: number[] = [];

        if (isSelected) {
          // Handle selecting a company
          const currentSubscribed = existingItem
            ? existingSubscribed
            : companies.filter((c) => c.companySubscribed).map((c) => c.companyId);
          newSubscribed = [...currentSubscribed, companyId].filter((v, i, a) => a.indexOf(v) === i);
          newUnsubscribed = existingUnsubscribed.filter((id) => id !== companyId);
          setLocalSearchSubscribedCount(localSearchSubscribedCount + 1);
          setLocalSubscribedCount(localSubscribedCount + 1);
          setLocalCount(localCount + 1);
        } else {
          // Handle unselecting a company
          // Initialize with currently subscribed companies from search results
          const currentSubscribed = existingItem && existingSubscribed.length > 0
            ? existingSubscribed
            : companies.filter((c) => c.companySubscribed && currentCompanies.includes(c.companyId)).map((c) => c.companyId);
          newSubscribed = currentSubscribed.filter((id) => id !== companyId);
          newUnsubscribed = [...existingUnsubscribed, companyId].filter((v, i, a) => a.indexOf(v) === i);
          setSubsrcibedCompanies((prev) => {
            const updated = prev.filter((id) => id !== companyId);
            return Array.from(new Set([...updated, ...newSubscribed]));
          });
          setUnSubscribedCompanies((prev) => Array.from(new Set([...prev, companyId])));
          setLocalSearchSubscribedCount(localSearchSubscribedCount - 1);
          setLocalSubscribedCount(localSubscribedCount - 1);
          setLocalCount(localCount - 1);
        }
        // Calculate isSelectAll - true if all search results are selected
        const isSelectAll = newSubscribed.length === currentCompanies.length;

        const updatedItem = {
          searchTerm: searchText,
          subscribedCompanies: newSubscribed,
          unsubscribedCompanies: newUnsubscribed,
          isSelectAll:
            toggleSource === 'search' && isToggleClicked
              ? isSelectAll
              : false,
        };

        const existingIndex = prev.findIndex(
          (item) => item.searchTerm === searchText,
        );
        const updated = [...prev];

        if (existingIndex !== -1) {
          updated[existingIndex] = {
            ...updated[existingIndex],
            ...updatedItem,
          };
        } else {
          updated.push(updatedItem);
        }
        return updated;
      });
    }
  };

  const isChecked = (companyId: number) => {
    if (searchText.trim() !== '') {
      const currentSearch = searchList.find((item) => item.searchTerm === searchText);
      if (currentSearch) {
        if (currentSearch.isSelectAll) {
          return !currentSearch.unsubscribedCompanies.includes(companyId);
        }
        return currentSearch.subscribedCompanies.includes(companyId);
      }
      // Fallback to company subscription state from companies array
      const company = companies.find((c) => c.companyId === companyId);
      return company ? company.companySubscribed : false;
    }
    if (isAllSelected) {
      return !unsubscribedCompanies.includes(companyId);
    }
    return subscribedCompanies.includes(companyId) && !unsubscribedCompanies.includes(companyId);
  };

  return (
    <StyleWrapper sectionHeight={companyHeight}>
      <NavBarPrimary headerClassName="no-overflow-on-header">
        <div className="left-side-wrap" />
        <div className="right-side-wrap">
          {isActive() ? (
            <>
              <GlobalSearch iconMode={isTab} />
              <DrawerAlerts />
              <AccountPopOver />
            </>
          ) : (
            <GlobalButton
              title="Login"
              textColor="#ffffff"
              bgColor="#1EC252"
              borderRadius="25px"
              innerSpace="8px 20px"
              PaddingSm="4px 16px 6px 16px"
              height="36px"
              fontSize="18px"
              fontSizeSm="16px"
              buttonClassName="button-follow"
              onButtonClick={() => navigate('/')}
            />
          )}
        </div>
      </NavBarPrimary>
      <div className="main-container">
        <div className="first-section" ref={container1Ref}>
          <div className="left-side">
            <p className="main-heading">Daily IQ</p>
            <p className="sub-heading">To receive alerts please click on the toggle </p>
          </div>
          <div className="right-side">
            <p>Active</p>
            <Switch checkedChildren="On" unCheckedChildren="Off" checked={currentValue} onClick={() => stopEmail()} />
          </div>
        </div>
        <div className="second-section">
          <div className="headings-content" ref={container2Ref}>
            <div className="headings">
              <span className={`main-heading ${translateSkipAreas}`}>
                {`My Accounts (${subscribedCount}/${companiesCount})`}
                <HeadingWithToolTip toolTipText={TOOLTIP_DAILYIQ} />
              </span>
              <span className="sub-heading">
                Customize you Daily IQ by selecting which companies you want to include/exclude
              </span>
            </div>
            <div className="filter-wrapper">
              <div className="search-wrapper" ref={container3Ref}>
                <Input
                  size="small"
                  placeholder="Search my accounts"
                  onChange={searchQueryChange}
                  prefix={<SearchGlobalIcon />}
                  value={value}
                  onPressEnter={triggerSearch}
                  maxLength={50}
                />
                {value.length ? <Cross className="clear-search" onClick={(e: any) => clearSearch(e)} /> : null}
              </div>
              {/* <div className="filter-dailyiq-dashboard">
                <FilterDropdown
                  filterOptions={filterOptions}
                  handleFilterChange={handleFilterChange}
                />
              </div> */}
              {companiesLength > 0 && (
                <div className="select-options">
                  <Button onClick={handleToggle} className={`filter-btn ${toggleText === 'Unselect All' ? 'active' : ''}`}>
                    {searchText !== '' ? searchToggleText : toggleText}
                  </Button>
                </div>
              )}
              <GlobalButton
                title="Submit"
                outlineColor={primaryColor}
                textColor="#FFF"
                bgColor={primaryColor}
                height="33px"
                borderRadius="8px"
                buttonClassName="submit-btn"
                onButtonClick={() => {
                  submitCompanies();
                }}
                disabled={isDisabled}
              />
            </div>
          </div>
          <div className="companies-section">
            <div className="company-display">
              <InfiniteScroll
                dataLength={companies?.length}
                next={fetchMoreCompanies}
                hasMore
                loader={loading && getCompaniesLoadingSkeleton()}
                className="o-x-hidden o-y-hidden infinite-for-company-section"
              >
                {(loading && companiesLength === 0)
                  || (loading && (searchText.length === 0 || searchText.length) && !loadMore) ? (
                  getCompaniesLoadingSkeleton()
                ) : !loading && companiesLength === 0 ? (
                  <div className="no-data">
                    <p className="no-results">No Results Found</p>
                  </div>
                ) : (
                  <Row className="Grid-width-row white-layer-col" gutter={[24, 24]} style={{ margin: '0' }}>
                    {companies.length
                      ? companies.map((company) => (
                        <Col
                          key={company.companyId} // Added key prop
                          xxl={{ span: 4 }}
                          xl={{ span: 4 }}
                          lg={{ span: 8 }}
                          md={{ span: 12 }}
                          sm={{ span: 12 }}
                          className="gutter-row"
                        >
                          <CompanyCardLarge
                            key={company?.companyId}
                            companyData={company}
                            removeButton
                            removed={isChecked(company.companyId)}
                            isDailyIQ
                            handleCompanyRemoved={(selected?: boolean) => {
                              handleRemoveCompany(selected, company.companyId);
                            }}
                          />
                        </Col>
                      ))
                      : null}
                  </Row>
                )}
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>
    </StyleWrapper>
  );
};

export default DailyIQCompanies;
